module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/NoResults/chat-c5b1f0ebe703b09f57b2f8f8b9fff8d4.svg";